import React from 'react';
import FieldItem from "./option-item/field-item";
import {SEPARATOR} from "../../../../../gd-components/popover-menu/const"
import {PopoverAddFieldsListProps} from "./index"

export default function SystemFields(props:PopoverAddFieldsListProps) {

    const group = _.find(props.manageColumnsConfig, group=>group.groupId === props.section)

    let separatorAdded = true; // required for separator to be placed only after any other option, not other separator

    const options = _(group.fields).map(fieldId=>{
        switch (fieldId) {
            case 'separator':
                if (separatorAdded) return false;
                separatorAdded = true;
                return fieldId;

            default:
                separatorAdded = false;
                return _.find(props.fields, field=>field.fieldId === fieldId)
        }
    }).compact().value();

    const hasIcons = !!_.find(options, o=>o.icon) || !!props.noValueOption?.icon;

    return (
        <>
            {_.map(options, (option,key)=>{
                switch (option) {
                    case SEPARATOR  :
                        return <div key={key} className="separator"/>;

                    default         :
                        const selectedColumn = _.find(props.columns, column=>column.fieldId === option.fieldId)
                        return <FieldItem key                   = {option.fieldId}
                                          field                 = {option}
                                          params                = {selectedColumn?.params}
                                          selected              = {!!selectedColumn}
                                          hasIcons              = {hasIcons}
                                          showModifierOptions   = {props.showModifierOptions}
                                          disabled              = {props.mandatoryColumnsIds?.includes(option.fieldId)}
                                          onClick               = {props.onToggleColumn}/>
                }
            })}
        </>
    )
}